export const APP_NAME = process.env.VUE_APP_NAME || "Nudool";
